
import { NgModule } from '@angular/core';
import { ErrorTracingModule } from '../error-tracing/error-tracing.module';
import { UserAuthService } from './user-auth.service';

@NgModule({
    imports: [
        ErrorTracingModule,
    ],
    providers: [
        UserAuthService,
    ],
})
export class UserAuthModule {}